import { Box } from "@mui/material";
import Header from "../../components/Header";
import moment from "moment";
import { createContext, useEffect, useState } from "react";
import FilterForm from "../../components/FilterForm/HistoryFilterForm";
import DashBoardTable from "../../components/Table/DashboardTable";
import HistroyTable from "../../components/Table/HistroyTable";

export const TableContext = createContext(null);

const DashBoard = () => {
  const [showHistory, setShowHistory] = useState(false);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);
  const [filters, setFilters] = useState([
      {
        name: "utility_code",
        value: "",
      },
      {
        name: "state_id",
        value: "",
      },
      {
        name: "commodity",
        value: "",
      },
      {
        name: "class",
        value: ""
      },
      {
        name: "date",
        value: ["", ""],
      }
    ]);

  const handleReset = () => {
    setFilters([
      {
        name: "utility_code",
        value: "",
      },
      {
        name: "state_id",
        value: "",
      },
      {
        name: "commodity",
        value: "",
      },
      {
        name: "class",
        value: ""
      },
      {
        name: "date",
        value: ["", ""]
      }
    ])
  };

  const handleSubmitFilter = (val) =>{
    setFilterLoading(true);
    setTimeout(() => {
      setFilters(val);
      setFilterLoading(false);
    }, 1000);
  }

  const handleChangeData = (val) =>{
    setData(val);
  }

  const handleChangeLoading = (val) =>{
    setLoading(val)
  }

useEffect(() => {
  const dateFilter = filters.find(filter => filter.name === "date");
  if (!dateFilter) {
    setShowHistory(false);
    return;
  }
  const [start, end] = dateFilter.value || ["", ""];
  const hasDateValues = start !== "" && end !== "";
  if (!hasDateValues) {
    setShowHistory(false);
    return;
  }
  const startM = moment(start);
  const endM = moment(end);
  const isSameDay = startM.isSame(endM, "day");
  setShowHistory(hasDateValues && !isSameDay);
}, [filters]);
  return (
    <Box className="w-full h-full min-h-[100vh] bg-[#EAF4FC]">
      <Header />
      <div className="w-full flex justify-center">
        <div className="w-[92%]  bg-white">
          <FilterForm
            rows={data}
            handleSubmit={handleSubmitFilter}
            handleReset={handleReset}
            filters={filters}
          />
        </div>
      </div>
      <TableContext.Provider
        value={{
          loading,
          filters,
          filterLoading,
          handleChangeData,
          handleChangeLoading
        }}
      >
         {showHistory ? <HistroyTable/> : <DashBoardTable/>}
      </TableContext.Provider>
    </Box>
  );
};
export default DashBoard;
